<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>Accounts Details</v-toolbar-title>
    </v-toolbar>
    <v-layout row wrap v-if="details && details.invoice">
      <v-flex md4 class="pa-4">
        <div>
          <strong>Invoice Amount</strong><br />
          <p>{{mA(details.invoice.amount)}}</p>
        </div>
        <div>
          <strong>Commission ({{ details.invoice.coordinator_commission_parcent }}%)</strong><br />
          <p>{{ mA(commissionAmount) }}</p>
        </div>
      </v-flex>
      <v-flex md4 class="pa-4">
        <div>
          <strong>VAT ({{ details.invoice.vat }})</strong><br />
          <p>{{mA(details.invoice.vat_amount)}}</p>
        </div>
        <div>
          <strong>Profit</strong><br />
          <p>{{ mA(totalProfit - commissionAmount) }}</p>
        </div>
      </v-flex>
      <v-flex md4 class="pa-4">
        <div>
          <strong>Expense</strong><br />
          <p>{{ mA(totalExpense) }}</p>
        </div>
        <div>
          <strong>Dues</strong><br />
          <p>{{ mA(details.invoice.amount - totalReceives) }}</p>
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { columnSum, moneyAmount } from "../../mdsir/MdsirUtils";
export default {
  props: ["details"],
  // data() {
  //   return {
  //     // relatedFiles: [],
  //   };
  // },

  computed: {
    totalExpense(){
      const { payments } = this.details;
      let sum = 0;
      if(payments && payments.length > 0){
        sum = columnSum(payments, 'amount');
      }
      return sum;
    },
    totalReceives(){
      const { receives } = this.details;
      let sum = 0;
      if(receives && receives.length > 0){
        sum = columnSum(receives, 'amount');
      }
      return sum;
    },
    totalProfit(){
      const { invoice } = this.details;
      return invoice.amount - (invoice.vat_amount + this.totalExpense);
    },
    commissionAmount(){
      const { invoice:{coordinator_commission_parcent} } = this.details;
      return this.totalProfit * coordinator_commission_parcent/100;
    }
  },
};
</script>
